export default __webpack_public_path__ + "9efd4b0e148d28c9d85f148ccf4e2d81.png";